import { getMarkRange, mergeAttributes } from "@tiptap/core";
import { Link as TiptapLink } from "@tiptap/extension-link";
import { Plugin, TextSelection } from "@tiptap/pm/state";

import LinkEditPopover from "../../extensions/Link/components/LinkEditPopover";

export const Link = TiptapLink.extend({
	inclusive: false,
	parseHTML() {
		return [
			{
				tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])'
			}
		];
	},
	renderHTML({ HTMLAttributes }) {
		return [
			"a",
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				class: "link"
			}),
			0
		];
	},

	addOptions() {
		return {
			...this.parent?.(),
			openOnClick: true,
			button: ({ editor, t }) => {
				return {
					component: LinkEditPopover,
					componentProps: {
						editor,
						action: value => {
							const { link, text, openInNewTab } = value;
							editor
								.chain()
								.extendMarkRange("link")
								.insertContent({
									type: "text",
									text,
									marks: [
										{
											type: "link",
											attrs: {
												href: link,
												target: openInNewTab ? "_blank" : null,
											}
										}
									]
								})
								.setLink({ href: link })
								.focus()
								.run();
						},
						id: "linkk",
						isActive: () => editor.isActive("link") || false,
						icon: "Link",
						tooltip: t("editor.link.tooltip")
					}
				};
			}
		};
	},

	addProseMirrorPlugins() {
		return [
			new Plugin({
				props: {
					handleClick: (view, pos) => {
						const { schema, doc, tr } = view.state;
						const range = getMarkRange(doc.resolve(pos), schema.marks.link);
						if (!range) {
							return false;
						}
						const $start = doc.resolve(range.from);
						const $end = doc.resolve(range.to);
						const transaction = tr.setSelection(new TextSelection($start, $end));
						view.dispatch(transaction);
					}
				}
			})
		];
	}
});
